import { Box} from '@mui/material'
import { useNavigate } from 'react-router-dom';
import './index.css'
function HcpFooter() {
    return (
      <Box className="footer-container" >
        <Box className="navigations" sx={{justifyContent: 'left', textTransform: 'uppercase'}} >
          <a href='https://pro.freestyle.abbott/uk-en/home/why-freestyle-libre-systems.html'>Why FreeStyle Libre Systems?</a>
          <a href='https://pro.freestyle.abbott/uk-en/home/freestyle-portfolio.html'>FreeStyle Portfolio</a>
          <a href='https://pro.freestyle.abbott/uk-en/home/scientific-resources-education.html'>Scientific Resources & Education</a>
          <a href='#'>Libre Academy</a>
          <a href='#'>Libre Primary Care Hub</a>
          <a href='https://pro.freestyle.abbott/uk-en/home/help-support.html'>Help & Support</a>
        </Box>
        <div className='horizontal-line'></div>
        <div className='logo-footer'>
          <img src={process.env.PUBLIC_URL +'/abbott-white-logo.png'} alt='abbott logo'/>
        </div>
        <Box className="other-navigations" >
          <a href='https://pro.freestyle.abbott/uk-en/privacy-policy.html'>Privacy Notice</a>
          <a href='https://pro.freestyle.abbott/uk-en/home/terms-and-conditions.html'>Terms and Conditions of Use</a>
          <a href='https://pro.freestyle.abbott/uk-en/home/cookie-policy.html'>Cookie Policy</a>
            <div id="teconsent"></div>
        </Box>
        <div className='footer-text'>
         <span>
         The sensor housing, FreeStyle, Libre, and related brand marks are marks of Abbott. Other trademarks are the property of their respective owners. No use of any Abbott trademark, trade name, or trade dress in this site may be made without the prior written authorisation of Abbott Laboratories, except to identify the product or services of the company.
         </span>
         <span>
         This website and the information contained herein is intended for use by residents of the United Kingdom. The product images are for illustrative purposes only.
         </span>
         <span>
         ©️ {new Date().getFullYear()} Abbott. All rights reserved.
         <br />
         Registered Number: 329102 England. Registered Office: Abbott House, Vanwall Business Park, Vanwall Road, Maidenhead, Berkshire, SL6 4XE
         </span>
        </div>
      </Box>
    );
  }
  
  export default HcpFooter;
